import {styled} from "@mui/material/styles";
import {TableCell} from "@mui/material";

export const BorderedTableCell = styled(TableCell)(({theme}) => ({
  border: `1px solid ${theme.palette.divider}`,
}));

